"use client";
import React, { useEffect, useState } from "react";
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";

interface Option {
  name: string;
  name_ar: string;
  value: string;
}

interface FilterButtonProps {
  text: string;
  options?: Option[];
  onSelect: (option: string) => void;
  isOpen: boolean;
  onToggle: () => void;
  restartFillter: any;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  text,
  options = [],
  onSelect,
  isOpen,
  onToggle,
  restartFillter,
}) => {
  const lang =
    typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "";
  const isArabic = lang === "ar";
  const [selected, setSelected] = useState({value: ''});

  useEffect(()=>{
    console.log('selected ',options)
    if(options.length > 0){
      setSelected(options[0])
    }
  },[restartFillter])

  return (
    <div className="relative w-auto min-w-[120px]">
      <div
        className="text-[#4f8be0] dark:text-gray-100 sm:h-[52px] h-10 sm:px-6 px-4 py-3.5 rounded-2xl border border-[#ecedf5] flex justify-between sm:gap-2 gap-1 items-center cursor-pointer"
        onClick={onToggle}
      >
        <span className="sm:text-sm sm:font-semibold text-xs font-medium">
          {selected.value == '' ? text : (isArabic ? selected?.name_ar : selected?.name)}
        </span>
        {isOpen ? <FaAngleUp /> : <FaAngleDown />}
      </div>

      {isOpen && (
        <div className="absolute left-0 right-0 mt-2 bg-white dark:bg-gray-800 rounded-lg shadow-lg z-10">
          {options.map((option) => (
            <div
              key={option.value}
              className={`px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 m-1 rounded-md ${option == selected ? 'bg-blue-400 text-white': ''}`}
              onClick={() => onSelect(option.value) + setSelected(option)}
            >
              {isArabic ? option.name_ar : option.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterButton;
